namespace AgerLMS.Coaching {
    export interface ChartDataSeries {
        id?: string;
        name?: string;
        data?: number[];
        marker?: SeriesMarker;
    }
}
